// index.js
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import './index.css';
 import variationItems from './skus.json';

// const variationItems = Array.from(document.getElementsByClassName('youtube-live-item')).map((item) => ({
//   product_id: item.getAttribute('data-product-id'),
//   product_name: item.getAttribute('data-product-name'),
//   product_image: item.getAttribute('data-product-image'),
//   product_price: item.getAttribute('data-price'),
//   product_sku: item.getAttribute('data-sku'),
// }));

ReactDOM.render(
  <React.StrictMode>
    <App variationItems={variationItems} />
  </React.StrictMode>,
  document.getElementById('root')
);
